module.exports = "/_next/static/images/uv-rotate-aa76b3a5286b9e1e159c8b12d9fee561.png";